import React, { Component } from 'react';
import { Table, Space, PageHeader } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from '../redux/actions/agents';
import { EditOutlined } from '@ant-design/icons';
import AgentProduct from './AgentProduct';

class AgentDetail extends Component {

    handleOnClick=()=>{
        this.props.onOpenEdit();
    }
    render() {
        const dataSource = [];
        let item={
            ...this.props.agentDetail,
            key:this.props.agentDetail.id,
            balance:`${this.props.agentDetail.balance}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        };
        dataSource.push(item);
        const columns = [
            {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
            },
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Mobile',
                dataIndex: 'mobile',
                key: 'mobile',
            },
            {
                title: 'Balance',
                dataIndex: 'balance',
                key: 'balance',
            },
            {
                title: 'Action',
                dataIndex: 'action',
                render: (text, record) => (
                    <Space size="middle">
                        <a onClick={this.handleOnClick}><EditOutlined /> Edit</a>
                    </Space>
                ),
            },
        ];
        return (
            <>
                <PageHeader
                    className="site-page-header"
                    title="AgentDetail"
                />
                <Table key={this.props.agentDetail.id} pagination={false} dataSource={dataSource} columns={columns} />
                <AgentProduct />
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        error: state.agents.error,
        loading: state.agents.loading,
        agentDetail: state.agents.agentDetail
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onOpenEdit:()=>dispatch(actions.openAgentEdit())
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AgentDetail));